<div>
  <div class="field-name mt-4">{{adspRegion}} {{dspType }} </div>
  <div class="field-name mt-4">{{commissionLabel | titlecase}}</div>
  <div class="flex_row">
    <mat-form-field class="name_input" appearance="outline" floatLabel="always" [hideRequiredMarker]="false"
      *ngIf="commissionType == 'vdsp_oc'">
      <mat-label>Commission Type</mat-label>
      <mat-select required [(ngModel)]="commissionEntry" placeholder="Choose One" [multiple]="false" (selectionChange)="showCommissionSetup()">
        <mat-option *ngFor="let entry of commissionEntities" [value]="entry.value">
          {{ entry.label }}
        </mat-option>
      </mat-select>
      <mat-error>
        Please select commission entity
      </mat-error>
    </mat-form-field>
  </div>
  <ng-container [formGroup]="commissionForm">
    <div class="flex_row ">
      <mat-form-field class="name_input me-2" appearance="outline" floatLabel="always" [hideRequiredMarker]="false">
        <mat-label>{{commissionEntry &&  commissionEntry == 'value_on_cpm' ? 'Commission in $' :adServiceFee.has(commissionType) ? getCurrencyFee() :'Commission %'}}</mat-label>
        <input [min]="minCommission" [max]="maxCommission"
          [(ngModel)]="commission.commission" (keyup)="validateCommission()" style="height: auto;" matInput required
          type="number" disableScrollOnNumber [errorStateMatcher]="matcher" placeholder="Enter {{commissionLabel}}" formControlName="commission" />
        <mat-error *ngIf="commissionForm.hasError('required', 'commission')">
          Please enter {{commissionLabel}}
        </mat-error>
        <mat-error *ngIf="commissionForm.hasError('min', 'commission') || commissionForm.hasError('max', 'commission')">
          Value should be between {{minCommission}} to {{maxCommission}}
        </mat-error>
        <mat-error *ngIf="commissionForm.hasError('float', 'commission')">
        Maximum of 2 decimal places allowed
      </mat-error>
    </mat-form-field>
    </div>
    <div class="flex_row set-margin-top">
      <mat-form-field class="name_input input-filed" appearance="outline" floatLabel="always"
        [hideRequiredMarker]="false">
        <mat-label>Effective date ({{ dspType.includes('Amazon') ? 'UTC' : clientTimeZone }})</mat-label>
        <input (dateChange)="validateCommission()" style="height: auto;" matInput
          required type="datetime" placeholder="dd-mmm-yyyy" [matDatepicker]="datePicker" formControlName="date"
          [(ngModel)]="commission.start_date" [errorStateMatcher]="matcher" [min]="minDate" />
        <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
        <mat-datepicker #datePicker [calendarHeaderComponent]="datePickerHeader">
        </mat-datepicker>
        <mat-error *ngIf="commissionForm.hasError('pastDate', 'date')">
          Effective date should be in the future
        </mat-error>
      </mat-form-field>
    </div>
  </ng-container>

  <button
    (click)="setCommission()"
    *ngIf="dspType != 'Global Audiences & Inventory - Old'"
    mat-button
      [ngClass]="{
      'create-btn-disabled':
        commissionLabel == 'System Deal Commission'
          ? !isCommissionValid || whiteLabelMode
          : !isCommissionValid,
      'create-btn': true,
      'me-2': true
    }"

    [disabled]="
      commissionLabel == 'System Deal Commission'
        ? !isCommissionValid || whiteLabelMode
        : !isCommissionValid
    "
  >
      save
   </button>

  <button
    *ngIf="
      step_input.initialState == 'on_hold' &&
      dspType != 'Global Audiences & Inventory - Old'
    "
    (click)="setImmediateCommission()"
    mat-button
      [ngClass]="{
      'create-btn': true,
      'me-2': true
    }"
  >
    save immediately
  </button>

  <div class="processing-message mt-3">
    Active {{ adServiceFee.has(commissionType) ? "Fee" : "Commission" }}:
    {{getActiveCommission()}}</div>
  <div>
    <table mat-table #commissionHistorySort="matSort" [dataSource]="commissionHistoryDataSource" style="width: 90%"
      matSort>
      <ng-container matColumnDef="start_date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="table_header_name">Start Date</span>
        </th>
        <td mat-cell *matCellDef="let row">
          <span class="table_value_name"> {{ row.start_date }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="end_date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="table_header_name">End Date</span>
        </th>
        <td mat-cell *matCellDef="let row">
          <span class="table_value_name"> {{ row.end_date || "-" }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="commission">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="table_header_name">
            {{ commissionLabel }}
            {{
              adServiceFee.has(commissionType)
                ? getCurrency()
                : commissionType == 'vdsp_oc' ? '': "%"
            }}</span
          >
        </th>
        <td mat-cell *matCellDef="let row">
          <span class="table_value_name"> {{ row.commission }}</span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayAdspColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayAdspColumns"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="13">No data available</td>
      </tr>
    </table>
    <mat-paginator #commissionHistoryPaginator [pageSizeOptions]="[5, 10, 25, 100]" (page)="handlePageEvent($event)"
      [length]="dataPageLength" style="width: 90%"></mat-paginator>
  </div>
</div>
